import React, { useState } from "react";
import Table from "@cloudscape-design/components/table";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Header from "@cloudscape-design/components/header";
import Modal from "@cloudscape-design/components/modal";
import FormField from "@cloudscape-design/components/form-field";
import Input from "@cloudscape-design/components/input";
import Alert from "@cloudscape-design/components/alert";
import { useTranslation } from "react-i18next";

export default function AdminsList({ admins, loading, onAdd, onRemove }) {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = useState(false);
  const [newAdminEmail, setNewAdminEmail] = useState("");
  const [error, setError] = useState("");
  const [addLoading, setAddLoading] = useState(false);

  const handleAdd = async () => {
    setError("");
    if (!newAdminEmail.trim()) {
      setError(t("auth.field.email"));
      return;
    }

    setAddLoading(true);
    try {
      await onAdd(newAdminEmail.trim());
      setShowAddModal(false);
      setNewAdminEmail("");
    } catch (err) {
      setError(err.message);
    } finally {
      setAddLoading(false);
    }
  };

  return (
    <>
      <Table
        loading={loading}
        loadingText={t("app.main.loading")}
        columnDefinitions={[
          {
            id: "email",
            header: t("auth.field.email"),
            cell: (item) => item,
          },
          {
            id: "actions",
            header: t("feeds.list.actions"),
            cell: (item) =>
              item !== "guymor@amazon.com" && (
                <Button
                  variant="icon"
                  iconName="remove"
                  onClick={() => {
                    if (window.confirm(`Remove admin access for ${item}?`)) {
                      onRemove(item);
                    }
                  }}
                />
              ),
          },
        ]}
        items={admins}
        empty={
          <Box textAlign="center" color="inherit">
            <b>{t("admin.list.no-admins")}</b>
          </Box>
        }
        header={
          <Header
            counter={`(${admins.length})`}
            actions={
              <Button variant="primary" onClick={() => setShowAddModal(true)}>
                {t("admin.action.add-admin")}
              </Button>
            }
          >
            {t("admin.section.administrators")}
          </Header>
        }
      />

      <Modal
        visible={showAddModal}
        onDismiss={() => {
          setShowAddModal(false);
          setError("");
          setNewAdminEmail("");
        }}
        header={t("admin.action.add-admin")}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={() => setShowAddModal(false)}>
                {t("admin.action.cancel")}
              </Button>
              <Button variant="primary" onClick={handleAdd} loading={addLoading}>
                {t("admin.action.add")}
              </Button>
            </SpaceBetween>
          </Box>
        }
      >
        <SpaceBetween size="m">
          {error && <Alert type="error">{error}</Alert>}
          <FormField label={t("auth.field.email")}>
            <Input value={newAdminEmail} onChange={({ detail }) => setNewAdminEmail(detail.value)} placeholder="user@example.com" type="email" />
          </FormField>
        </SpaceBetween>
      </Modal>
    </>
  );
}
